module.exports = {
  url: '/offer/:slug',
  template: require('raw!templates/offersDetail/offersDetail-view.html'),
  controller: OffersDetailController,
  controllerAs: 'offersDetailCtrl',
  params: {
    slug: null
  }
};

function OffersDetailController($scope, $state, store, $window, contentful, $http, Socialshare, $document, $timeout) {
  var vm = this;
  $window.scrollTo(0, 0);
  $scope.page = 'offer'

  console.log('slug', $state.params.slug);
  if ($state.params.slug) {
    var queryString = "content_type=offer&fields.slug=" + $state.params.slug;
    contentful.entries(queryString).then(function (res) {
      $scope.offer = res.data.items[0];
      console.log('offer', $scope.offer);
      var seoData = res.data.items[0];
      if (seoData.fields.seoPageTitle) {
        document.title = seoData.fields.seoPageTitle;
      }
      if (seoData.fields.seoPageDescription) {
        var meta = document.getElementsByTagName("meta");
        for (var i = 0; i < meta.length; i++) {
          if (meta[i].name.toLowerCase() === "description") {
            meta[i].content = seoData.fields.seoPageDescription;
          }
        }
      }
    })

  }
  $timeout(function () {

  }, 500);


  vm.trustUrl = "trustUrl";

  trustUrl.$inject = ['$sce'];

  function trustUrl($sce) {
    return function (mediaUrl) {
      return $sce.trustAsResourceUrl(mediaUrl);
    };
  }

  // vm.socialShare = function (share) {
  //   if (share === 'facebook') {
  //     Socialshare.share({
  //       'provider': 'facebook',
  //       'attrs': {
  //         'socialshareUrl': 'http://peaks-hotel.herokuapp.com/rooms',
  //         'socialshareQuote': 'Peaks Hotel | Rooms',
  //         'socialshareMedia': 'https://peaks-hotel.herokuapp.com/images/_new assets/peaks-logo-social.png',
  //         'socialsharePopupHeight': '400',
  //         'socialsharePopupWidth': '400'
  //       }
  //     });
  //   } else if (share === 'twitter') {
  //     Socialshare.share({
  //       'provider': 'twitter',
  //       'attrs': {
  //         'socialshareUrl': 'http://peaks-hotel.herokuapp.com/rooms',
  //         'socialshareText': 'Peaks Hotel | Rooms',
  //         'socialshareMedia': 'https://peaks-hotel.herokuapp.com/images/_new assets/peaks-logo-social.png',
  //         'socialsharePopupHeight': '400',
  //         'socialsharePopupWidth': '400'
  //       }
  //     });
  //   } else if (share === 'pinterest') {
  //     Socialshare.share({
  //       'provider': 'pinterest',
  //       'attrs': {
  //         'socialshareUrl': 'http://peaks-hotel.herokuapp.com/rooms',
  //         'socialshareText': 'Peaks Hotel | Rooms',
  //         'socialshareMedia': 'https://peaks-hotel.herokuapp.com/images/_new assets/peaks-logo-social.png',
  //         'socialsharePopupHeight': '400',
  //         'socialsharePopupWidth': '400'
  //       }
  //     });
  //   } else if (share === 'email') {
  //     Socialshare.share({
  //       'provider': 'email',
  //       'attrs': {
  //         'socialshare-subject': 'Peaks Hotel | Rooms',
  //         'socialshare-body': 'Take a look at the Peaks Hotel!'
  //       }
  //     });
  //   }
  // }
}


// WEBPACK FOOTER //
// ./components/templates/offersDetail/offersDetail-controller.js